import { Injectable } from "@angular/core";
import * as i0 from "@angular/core";
export class ClientProductService {
    calculatePrices(product, productVariant, productOptions) {
        if (productVariant.prices)
            return productVariant.prices;
        const prices = JSON.parse(JSON.stringify(product.prices));
        // iterate over all product prices to see if there are relative variant->optionValue->prices to add
        for (const productPrice of prices) {
            // iterate over all productOptions
            for (const optionKey in productVariant.options) {
                if (productVariant.options[optionKey]) {
                    const productOption = productOptions.find((option) => option.key === optionKey);
                    if (!productOption)
                        throw new Error(`could not find option ${optionKey} in given options!`);
                    const productValue = productOption.values.find((val) => val.value === productVariant.options[optionKey]);
                    if (!productValue)
                        throw new Error(`could not find option value ${optionKey}=${productVariant.options[optionKey]} in given options!`);
                    // find a matching price
                    if (productValue.prices instanceof Array && productValue.prices.length > 0) {
                        for (const optionPrice of productValue.prices) {
                            // if priceZone is being used, find matching price zone
                            if (productPrice.priceZoneId !== undefined) {
                                if (optionPrice.priceZoneId === productPrice.priceZoneId)
                                    productPrice.value += optionPrice.value;
                            }
                            // if priceZone is not being used, look for an option that also doesn't have a priceZone
                            else if (optionPrice.priceZoneId === undefined)
                                productPrice.value += optionPrice.value;
                        }
                    }
                }
            }
        }
        return prices;
    }
    getVariantForOptions(productVariants, options) {
        const variants = productVariants.filter((variant) => {
            for (const optionKey in options) {
                if (variant.options[optionKey] !== options[optionKey])
                    return false;
            }
            return true;
        });
        if (variants.length === 0)
            throw new Error("no variant found for given options, options are: " + JSON.stringify(options));
        if (variants.length > 1)
            throw new Error(`more than one variant found for given options, options are: ${JSON.stringify(options)}, variants are: ${JSON.stringify(variants)} (${variants.length}/${productVariants.length})`);
        return variants[0];
    }
}
ClientProductService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: ClientProductService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ClientProductService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: ClientProductService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: ClientProductService, decorators: [{
            type: Injectable
        }] });
